<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Check Application Status</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Check New Connection Application Status for consumers</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">

          <br>
          <b-row style="padding-top: 10px;">
                <b-col col cols="12" sm="3" md="3" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600" >Subdivision  <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="12" sm="3" md="3" lg="2">
                  <select name="subDivision" id="selectSubDiv" required style="margin:10px 10px">
      										<option value="000" disabled selected>Select</option>
      										<option value="001">001 - Fancybazar </option>
      										<option value="002">002 - Kalapahar </option>
      										<option value="003">003 - Fatashil </option>
      										<option value="004">004 - Paltanbazar </option>
      										<option value="005">005 - Ulubari </option>
      										<option value="009">009 - Basistha </option>
      										<option value="010">010 - Capital </option>
      										<option value="011">011 - Garbhanga </option>
      										<option value="013">013 - Sonapur </option>
      										<option value="014">014 - Chandmari </option>
      										<option value="015">015 - Narangi </option>
      										<option value="016">016 - Uzanbazar </option>
      										<option value="017">017 - Zoo Road </option>
      										<option value="021">021 - Amingaon </option>
      										<option value="022">022 - Hajo </option>
      										<option value="023">023 - Jalukbari </option>
      										<option value="024">024 - Sualkuchi </option>
      										<option value="027">027 - Boko </option>
      										<option value="028">028 - Chaygaon </option>
      										<option value="029">029 - Mirza </option>
      										<option value="030">030 - Azara </option>
      										<option value="032">032 - Abhayapuri </option>
      										<option value="033">033 - Bijni </option>
      										<option value="034">034 - Bongaigaon -I</option>
      										<option value="035">035 - Bongaigaon -II</option>
      										<option value="038">038 - Dhupdhara </option>
      										<option value="039">039 - Damra </option>
      										<option value="040">040 - Goalpara </option>
      										<option value="041">041 - Lakhipur </option>
      										<option value="042">042 - Mankachar </option>
      										<option value="044">044 - Agomoni </option>
      										<option value="045">045 - Bilasipara </option>
      										<option value="046">046 - Dhubri </option>
      										<option value="047">047 - Gauripur </option>
      										<option value="048">048 - Golokganj </option>
      										<option value="051">051 - Basugaon </option>
      										<option value="052">052 - Chapar </option>
      										<option value="053">053 - Fakiragram </option>
      										<option value="054">054 - Gossaigaon </option>
      										<option value="055">055 - Kokrajhar </option>
      										<option value="056">056 - Sapatgram ESC</option>
      										<option value="058">058 - Barpeta Road </option>
      										<option value="059">059 - Barpeta  </option>
      										<option value="060">060 - Sarbhog </option>
      										<option value="061">061 - Sarthebari </option>
      										<option value="064">064 - Chamata </option>
      										<option value="065">065 - Nalbari -I</option>
      										<option value="066">066 - Nalbari -II</option>
      										<option value="070">070 - Barama </option>
      										<option value="071">071 - Pathsala </option>
      										<option value="072">072 - Tihu </option>
      										<option value="076">076 - Baihata </option>
      										<option value="077">077 - Rangia -I</option>
      										<option value="078">078 - Rangia -II</option>
      										<option value="079">079 - Tamulpur </option>
      										<option value="083">083 - Kharupetia </option>
      										<option value="084">084 - Mangaldoi </option>
      										<option value="085">085 - Sipajhar </option>
      										<option value="088">088 - Mazbat </option>
      										<option value="089">089 - Tangla</option>
      										<option value="090">090 - Udalguri </option>
      										<option value="091">091 - Kalaigaon </option>
      										<option value="093">093 - Tezpur-I</option>
      										<option value="094">094 - Tezpur-II</option>
      										<option value="095">095 - Rangapara</option>
      										<option value="096">096 - Balipara</option>
      										<option value="100">100 - Dhekiajuli-I</option>
      										<option value="101">101 - Dhekiajuli-II</option>
      										<option value="105">105 - Chariali</option>
      										<option value="106">106 - Gohpur</option>
      										<option value="107">107 - Jamuguri</option>
      										<option value="108">108 - Sootea</option>
      										<option value="112">112 - Charaibahi</option>
      										<option value="113">113 - Jhargaon</option>
      										<option value="114">114 - Morigaon</option>
      										<option value="115">115 - Laharighat</option>
      										<option value="116">116 - Jagiroad</option>
      										<option value="119">119 - Hojai</option>
      										<option value="120">120 - Kathiatoli</option>
      										<option value="121">121 - Lanka</option>
      										<option value="122">122 - Nagaon-I</option>
      										<option value="123">123 - Nagaon-II</option>
      										<option value="124">124 - Nagaon-III</option>
      										<option value="126">126 - Dhing</option>
      										<option value="127">127 - Kaliabor</option>
      										<option value="129">129 - Samaguri</option>
      										<option value="130">130 - Raha</option>
      										<option value="132">132 - Hailakandi</option>
      										<option value="133">133 - Kalain</option>
      										<option value="134">134 - Lala</option>
      										<option value="135">135 - R.K. Nagar</option>
      										<option value="138">138 - Badarpur</option>
      										<option value="139">139 - Durlavcherra</option>
      										<option value="140">140 - Karimganj</option>
      										<option value="141">141 - Lowairpoa</option>
      										<option value="142">142 - Nilambazar</option>
      										<option value="143">143 - Patherkandi</option>
      										<option value="146">146 - Lakhipur</option>
      										<option value="147">147 - Silchar-I</option>
      										<option value="148">148 - Silchar-II</option>
      										<option value="149">149 - Sonai</option>
      										<option value="150">150 - Udharbond</option>
      										<option value="151">151 - Silchar-III</option>
      										<option value="153">153 - Diphu-I</option>
      										<option value="154">154 - Diphu -II</option>
      										<option value="155">155 - Lummding </option>
      										<option value="156">156 - Bokajan</option>
      										<option value="159">159 - Donkamokam</option>
      										<option value="160">160 - Howraghat</option>
      										<option value="161">161 - Kheroni</option>
      										<option value="162">162 - Hamren</option>
      										<option value="163">163 - Boithalangsu ESC</option>
      										<option value="164">164 - Haflong</option>
      										<option value="165">165 - Mahur</option>
      										<option value="166">166 - Maibong</option>
      										<option value="167">167 - Umrangso</option>
      										<option value="170">170 - Jorhat - I</option>
      										<option value="171">171 - Jorhat - II</option>
      										<option value="172">172 - Dergaon</option>
      										<option value="173">173 - Jorhat - III</option>
      										<option value="176">176 - Titabar</option>
      										<option value="177">177 - Mariani</option>
      										<option value="178">178 - Majuli</option>
      										<option value="181">181 - Golaghat -I</option>
      										<option value="182">182 - Bokakhat</option>
      										<option value="183">183 - Kamargaon</option>
      										<option value="184">184 - Sarupathar </option>
      										<option value="185">185 - Golaghat 2</option>
      										<option value="188">188 - Teok</option>
      										<option value="189">189 - Kakajan</option>
      										<option value="192">192 - Sivsagar 1</option>
      										<option value="193">193 - Sivsagar 2</option>
      										<option value="194">194 - Gaurisagar</option>
      										<option value="195">195 - Demow</option>
      										<option value="198">198 - Nazira</option>
      										<option value="199">199 - Amguri</option>
      										<option value="200">200 - Charaideo</option>
      										<option value="201">201 - Moran</option>
      										<option value="204">204 - Tingkhang</option>
      										<option value="207">207 - Dibrugarh 1</option>
      										<option value="208">208 - Dibrugarh 2</option>
      										<option value="209">209 - Dibrugarh 3</option>
      										<option value="212">212 - Digboi</option>
      										<option value="213">213 - Doomdooma</option>
      										<option value="214">214 - Margherita</option>
      										<option value="217">217 - Tinsukia 3</option>
      										<option value="218">218 - Chapakhowa</option>
      										<option value="219">219 - Naharkatia</option>
      										<option value="220">220 - Bordubi</option>
      										<option value="221">221 - Namrup</option>
      										<option value="224">224 - Tinsukia 1</option>
      										<option value="227">227 - N. Lakhimpur</option>
      										<option value="228">228 - Bihpuria</option>
      										<option value="229">229 - Nowboicha</option>
      										<option value="231">231 - Dhemaji</option>
      										<option value="232">232 - Dhakuakhana</option>
      										<option value="233">233 - Ghilamara</option>
      										<option value="234">234 - Gogamukh ESC</option>
      										<option value="236">236 - Chilapathar</option>
      										<option value="237">237 - Jonai</option>
      										<option value="299">299 - Tinsukia 2</option>
      									</select>
                </b-col>
                <b-col col cols="6" sm="3" md="3" lg="1" offset=1>
                  <b-button @click = "redirectUrl()" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                  </b-button>
                </b-col>
              </b-row>


    </br>
</div>

</b-container>

</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';

export default {
  name: '',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
    }
  },

  methods: {
    closeModal(){
      this.$bvModal.hide('model')
    },

redirectUrl()
		{

			var sV = document.getElementById("selectSubDiv").value;
			if(sV == '000')
      {
      	alert("Select a Subdivision");
        return
      }
			else

				var url = 'https://www.apdclrms.com/cbs/onlinecrm/newconnectionFinal?subdiv='+sV+'&applType=STATUS';
			{
				window.open( url, '_blank');
				
			}
		}
}
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
</style>
